import React from 'react';

import { Typography, Box, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useAppSelector } from 'hooks';

import Page from 'components/Page';
import SectionCard from 'components/SectionCard';

interface PageProps {}

const SelectSectionPage: React.FunctionComponent<PageProps> = () => {
    const theme = useTheme();
    const { auth } = useAppSelector((state) => state);

    const user = auth.user.object;

    return (
        <Page>
            <Container maxWidth="md" sx={{ pb: 4, mt: 4 }}>
                <Typography variant="h5">
                    Select a section to continue
                </Typography>
                <Box
                    sx={{
                        display: 'grid',
                        gap: 2,
                        my: 2,
                        [theme.breakpoints.down('md')]: {
                            gridTemplateColumns: '1fr',
                        },
                        [theme.breakpoints.up('md')]: {
                            gridTemplateColumns: '1fr 1fr',
                        },
                    }}
                >
                    <SectionCard
                        name="Ground Station Operations"
                        media="media/DALL.E-ground-station-operations.png"
                        summary="View and manage your Ground Stations"
                        to="/ground-stations"
                        disabled={
                            !(
                                user?.groups.includes(
                                    'Ground Station Operator',
                                ) || user?.isStaff
                            )
                        }
                    />
                    <SectionCard
                        name="Satellite Operations"
                        media="media/DALL.E-satellite-operations.png"
                        summary="View and Manage your Satellites"
                        to="/satellite-operations"
                        disabled={
                            !(
                                user?.groups.includes('Satellite Operator') ||
                                user?.isStaff
                            )
                        }
                    />
                    <SectionCard
                        name="Organisation Management"
                        media="media/DALL.E-organisation-management.png"
                        summary="Manage your assets, Users and Subscriptions"
                        to="/organisation"
                        disabled={
                            !(
                                user?.groups.includes('Organisation Manager') ||
                                user?.isStaff
                            )
                        }
                    />
                    <SectionCard
                        name="Alert Management"
                        media="media/DALL.E-sun-solar-storm-in-space.png"
                        summary="View and manage forecasted, current, and historic Weather Alerts"
                        to="/alerts"
                        disabled={!user}
                    />
                </Box>
            </Container>
        </Page>
    );
};

SelectSectionPage.displayName = 'SelectSectionPage';
export default SelectSectionPage;
